import { render, staticRenderFns } from "./ToggleDesign.vue?vue&type=template&id=4b1eba9f&scoped=true&"
import script from "./ToggleDesign.vue?vue&type=script&lang=ts&"
export * from "./ToggleDesign.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleDesign.vue?vue&type=style&index=0&id=4b1eba9f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1eba9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
